import React from "react";
import { Form } from "react-bootstrap";
import './style/form.css'

export const StepOnePatientName = ({patientDetails,isBookingDetail=true}) => {
    const { name, email, dob, address, genderAtBirth } = patientDetails;
    console.log('patientDetails',patientDetails)
    return (
        <div className="step-form">
            <div className="form-group">
                <label htmlFor="patientInfo">Patient</label>
                <div id="patientInfo" className={`patient-info ${isBookingDetail ? 'grayed-out' : ''}`}>
                    <div className="patient-name">{name}</div>
                    <div className="patient-details">
                       {`${email} , ${dob} , ${genderAtBirth} , ${address?.region}`}
                    </div>
                </div>
            </div>
        </div>
    );
};
